import { __extends } from "tslib";
import { Multiname } from './../abc/lazy/Multiname';
import { getExtClassField } from '../ext/external';
var LexImportsGenerator = /** @class */ (function () {
    function LexImportsGenerator() {
        this.imports = [];
    }
    LexImportsGenerator.prototype.test = function (mn) {
        return false;
    };
    LexImportsGenerator.prototype._genEntry = function (def) {
        return '//' + def.name;
    };
    LexImportsGenerator.prototype._genAlias = function (mn, options) {
        return mn.namespace.uri.replace(/\./g, '_') + '__' + mn.name;
    };
    LexImportsGenerator.prototype.findAliases = function (mn, findProp) {
        return this.imports.filter(function (e) {
            return e.name === mn && (findProp ? findProp === e.options.findProp : true);
        });
    };
    LexImportsGenerator.prototype.getLexAlias = function (mn, options) {
        return this.getPropStrictAlias(mn, Object.assign({ findProp: true }, options || {}));
    };
    LexImportsGenerator.prototype.getPropStrictAlias = function (mn, options) {
        if (options === void 0) { options = { findProp: false }; }
        var _a;
        if (!this.test(mn)) {
            throw "Can't generate static alias for " + mn.name + " of " + ((_a = mn.namespace) === null || _a === void 0 ? void 0 : _a.uri);
        }
        var def = this.imports.find(function (e) {
            return e.name === mn && options.findProp === e.options.findProp;
        });
        if (def) {
            return def.alias;
        }
        var alias = this._genAlias(mn, options);
        if (!this.imports.find(function (e) { return e.alias === alias; })) {
            this.imports.push({
                name: mn,
                alias: alias,
                options: options
            });
        }
        return alias;
    };
    LexImportsGenerator.prototype.genHeader = function (ident) {
        if (ident === void 0) { ident = ''; }
        if (!this.imports.length) {
            return '';
        }
        var header = ["\n" + ident + " /* " + this.constructor.name + " */"];
        for (var _i = 0, _a = this.imports; _i < _a.length; _i++) {
            var def = _a[_i];
            header.push(ident + ' ' + this._genEntry(def));
        }
        header.push('\n');
        return header.join('\n');
    };
    LexImportsGenerator.prototype.genBody = function (ident) {
        if (ident === void 0) { ident = ''; }
        return '';
    };
    LexImportsGenerator.prototype.reset = function () {
        this.imports.length = 0;
    };
    return LexImportsGenerator;
}());
export { LexImportsGenerator };
/**
 * Generate imports for all lex generators
 */
var ComplexGenerator = /** @class */ (function () {
    function ComplexGenerator(generators) {
        this.generators = generators;
        /**
         * Allowed collsion for alias of generator, return first alias;
         */
        this.allowColissions = false;
        if (!generators) {
            throw 'Generators array can\'t be null';
        }
    }
    /**
     * Return generator that will used for lex generation
     */
    ComplexGenerator.prototype.getGenerator = function (mn) {
        for (var _i = 0, _a = this.generators; _i < _a.length; _i++) {
            var g = _a[_i];
            if (g.test(mn)) {
                return g;
            }
        }
        return null;
    };
    ComplexGenerator.prototype.test = function (mn) {
        if (!this.generators.length) {
            return false;
        }
        return !!this.getGenerator(mn);
    };
    ComplexGenerator.prototype.findAliases = function (mn, findProp) {
        var res = [];
        for (var _i = 0, _a = this.generators; _i < _a.length; _i++) {
            var g = _a[_i];
            res = res.concat(g.findAliases(mn, findProp));
        }
        return res;
    };
    /**
     * Return generator that will used for propstrict generation
     */
    ComplexGenerator.prototype.getLexAlias = function (mn, options) {
        var _a;
        var gen = this.getGenerator(mn);
        if (!gen) {
            throw "Can't generate static alias for " + mn.name + " of " + ((_a = mn.namespace) === null || _a === void 0 ? void 0 : _a.uri);
        }
        return gen.getLexAlias(mn, options);
    };
    ComplexGenerator.prototype.getPropStrictAlias = function (mn, options) {
        var _a;
        var gen = this.getGenerator(mn);
        if (!gen) {
            throw "Can't generate static alias for " + mn.name + " of " + ((_a = mn.namespace) === null || _a === void 0 ? void 0 : _a.uri);
        }
        return gen.getPropStrictAlias(mn, options);
    };
    ComplexGenerator.prototype.genHeader = function (ident) {
        var header = '';
        for (var _i = 0, _a = this.generators; _i < _a.length; _i++) {
            var g = _a[_i];
            header += g.genHeader(ident);
        }
        return header;
    };
    ComplexGenerator.prototype.genBody = function (ident) {
        var header = '';
        for (var _i = 0, _a = this.generators; _i < _a.length; _i++) {
            var g = _a[_i];
            header += g.genHeader(ident);
        }
        return header;
    };
    ComplexGenerator.prototype.reset = function () {
        this.generators.forEach(function (e) { return e.reset(); });
    };
    return ComplexGenerator;
}());
export { ComplexGenerator };
/* -------------------- GENERATORS ------------------- */
/**
 * Import generator for Box2D and Nape external libs
 */
var PhysicsLex = /** @class */ (function (_super) {
    __extends(PhysicsLex, _super);
    function PhysicsLex(allows) {
        var _this = _super.call(this) || this;
        _this.allows = allows;
        _this.allows = Object.assign({ box2D: true, nape: true }, allows);
        return _this;
    }
    PhysicsLex.prototype._genEntry = function (def) {
        var uri = def.name.namespace.uri;
        var name = def.name.name;
        return "const " + def.alias + " = context.getStaticImportExt('" + uri + "', '" + name + "');";
    };
    PhysicsLex.prototype._genAlias = function (mn, options) {
        return mn.namespace.uri.replace(/\./g, '_') + '__' + mn.name;
    };
    PhysicsLex.prototype.test = function (mn) {
        var _a;
        var uri = (_a = mn.namespace) === null || _a === void 0 ? void 0 : _a.uri;
        if (!uri) {
            return false;
        }
        // generate static for box2D
        if (uri.startsWith('Box2D') && this.allows.box2D) {
            return !!getExtClassField(mn.name);
        }
        if (!uri.startsWith('nape.') || !this.allows.nape) {
            return false;
        }
        if (mn.name.includes('Debug')) {
            return false;
        }
        return true;
    };
    return PhysicsLex;
}(LexImportsGenerator));
export { PhysicsLex };
var ALLOWED_TOP_LEVEL_NAMES = [
    'flash.geom',
    'flash.utils',
    'Math',
    'trace'
];
var NOT_ALLOWED = [
    'getDefinitionByName',
    'SetIntervalTimer',
    'setTimeout',
    ':trace'
];
var TopLevelLex = /** @class */ (function (_super) {
    __extends(TopLevelLex, _super);
    function TopLevelLex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopLevelLex.prototype.test = function (mn) {
        var _a;
        var uri = ((_a = mn.namespace) === null || _a === void 0 ? void 0 : _a.uri) || '';
        var name = mn.name;
        if (typeof uri === 'undefined') {
            return false;
        }
        if (NOT_ALLOWED.indexOf(name) > -1 ||
            NOT_ALLOWED.indexOf(uri) > -1) {
            return null;
        }
        if ((ALLOWED_TOP_LEVEL_NAMES.indexOf(name) > -1 && !uri) || // trace, Math
            ALLOWED_TOP_LEVEL_NAMES.indexOf(uri) > -1) {
            return true;
        }
        return false;
    };
    TopLevelLex.prototype._genEntry = function (def) {
        var uri = def.name.namespace.uri;
        var name = def.name.name;
        var _a = def.options || {}, nameAlias = _a.nameAlias, findProp = _a.findProp;
        if (!nameAlias) {
            throw 'Name alias required for generatin Toplevel exports!';
        }
        var id = Number(nameAlias.replace('name', ''));
        var mnname = "['" + Multiname.getPublicMangledName(name) + "']";
        return "const " + def.alias + " = context.getTopLevel(" + id + ")" + (findProp ? mnname : '') + "; // " + uri + ":" + name;
    };
    TopLevelLex.prototype._genAlias = function (mn, options) {
        var uri = mn.namespace.uri.split(/\./g);
        if (!options.nameAlias) {
            throw 'Name alias required for generatin Toplevel exports!';
        }
        return uri.join('_') + "__" + mn.name + (options.findProp ? '' : '_def');
    };
    return TopLevelLex;
}(LexImportsGenerator));
export { TopLevelLex };
